import type { PurchaseScaleContent } from '../domain/landing.types'

const MIN_EMPHASIS = 1
const MAX_EMPHASIS = 6

type PurchaseScaleSectionProps = {
  content: PurchaseScaleContent
}

export function PurchaseScaleSection({ content }: PurchaseScaleSectionProps) {
  return (
    <section className="purchase-scale" id="escala" aria-labelledby="purchase-scale-title">
      <div className="purchase-scale__intro" id="volumen">
        <p>{content.eyebrow}</p>
        <h2 id="purchase-scale-title">{content.title}</h2>
        <span>{content.description}</span>
      </div>

      <ol className="purchase-scale__milestones" aria-label="Escalas de compra disponibles">
        {content.milestones.map((milestone) => {
          const emphasis = Math.min(MAX_EMPHASIS, Math.max(MIN_EMPHASIS, milestone.emphasis))

          return (
            <li
              className={`purchase-scale__milestone purchase-scale__milestone--${emphasis}`}
              key={milestone.label}
            >
              <span className="purchase-scale__quantity">{milestone.label}</span>
              <span className="purchase-scale__label">{milestone.supportingLabel}</span>
            </li>
          )
        })}
      </ol>

      <p className="purchase-scale__closing">{content.closingStatement}</p>
    </section>
  )
}
